var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * Это фикс для проблемы с кэшированием svg при использовании use в хроме.
 * В хроме на десктопе часть иконок иногда просто не отображаются. Вроде как проблема в том, что хром дважды прочитывает этот файл
 * из кэша - один раз из кэша в памяти, второй с диска. В результате разные элементы рендерят разные файлы (хотя технически это один файл),
 * при том, что один из этих файлов в памяти заменён и более не доступен. Как следствие, часть иконок не отображается.
 *
 * Для воспроизведения ошибки можно открыть какой-нибудь аромат в инкогнито в хроме на декстопе с включённым кэшем и несколько раз
 * перезагрузить страницу.
 *
 * Суть фикса заключается просто в том, что мы проходим по иконкам, и если иконка видима, но высота <use/> элемента равна нулю,
 * то мы его пересоздаём (через перезапись outerHTML).
 */
export default function initSvgSpriteFix() {
    var e_1, _a;
    var elements = document.querySelectorAll('svg.svg > use, svg.svg-clr > use');
    try {
        for (var elements_1 = __values(elements), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()) {
            var element = elements_1_1.value;
            // skip invisible elements
            if (!element.parentElement.getBoundingClientRect().height) {
                continue;
            }
            // skip rendered <use/> elements
            if (element.getBoundingClientRect().height) {
                continue;
            }
            // noinspection SillyAssignmentJS
            element.outerHTML = element.outerHTML;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (elements_1_1 && !elements_1_1.done && (_a = elements_1.return)) _a.call(elements_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
